import React, { Component } from 'react';
import { TextField, TextFieldProps } from '@mui/material';

import { withStyles } from '@mui/styles';

import APCurrencyInputStyles from './styles/APCurrencyInput.style';

class APCurrencyInput extends Component<TextFieldProps, {}> {
  render() {
    const props = {
      ...this.props,
      variant: "outlined" as "outlined"
    };

    return (
      <TextField {...props} />
    );
  }
}

export default withStyles(APCurrencyInputStyles)(APCurrencyInput);
